import { gql } from '@apollo/client';

export const REPORT_CONTENT = gql`
  mutation ReportContent($input: ReportInput!) {
    reportContent(input: $input) {
      success
      reportId
      message
    }
  }
`;
